{
  "Account": "Account",
  "AfternoonSlot": "Afternoon",
  "AllCategories": "All",
  "AlreadyHaveAccount": "Already have an account?",
  "Announcements": "Announcements",
  "AnyTimeSlot": "Any time",
  "Apply": "Apply",
  "AllSlotsBooked": "All slots are taken",
  "AreYouSure": "Are you sure?",
  "Back": "Back",
  "BackStep": "Back",
  "BasedOnReviews": "Based on {0} reviews",
  "BecomePartner": "Become a partner",
  "Birthday": "Birthday",
  "Book": "Book",
  "BookingConfirmedDescription": "See you at your appointment! You can view the details in your bookings.",
  "BookingConfirmedSuccess": "Appointment successfully booked!",
  "BookingStepOf": "Step {{current}} of {{total}}",
  "BlogSubtitle": "Tips, trends, and useful information from the world of beauty and health",
  "BlogTitle": "Blog",
  "BenefitEasyDesc": "Simple interface that anyone can use",
  "BenefitEasyTitle": "Easy to use",
  "BenefitFastDesc": "Book an appointment in less than a minute",
  "BenefitFastTitle": "Fast booking",
  "BenefitFreeDesc": "Using the platform is completely free",
  "BenefitFreeTitle": "Free",
  "BenefitRemindersDesc": "Get a reminder before your scheduled appointment",
  "BenefitRemindersTitle": "Reminders",
  "BookAppointment": "Schedule appointment",
  "CategoriesPageSubtitle": "Pick a service and book online",
  "CityPageSubtitle": "Book an appointment online in {{city}}",
  "BusinessNameLabel": "Business name",
  "BusinessNamePlaceholder": "Enter business name",
  "ByRegisteringAccept": "By registering I accept the",
  "BySubmittingAccept": "By submitting I accept the",
  "CancelBooking": "Cancel",
  "ChangePasswordTitle": "Password",
  "CloseButton": "Close",
  "CommentEncouragement": "Your comments mean a lot!",
  "CommentPlaceholder": "Enter a comment",
  "CompleteRegistration": "Complete registration",
  "CompleteRegistrationButton": "Complete registration",
  "CompleteRegistrationDescription": "Welcome! Please enter your phone number to complete the registration for",
  "ConfirmBooking": "Confirm",
  "Continue": "Continue",
  "MoreDetails": "More details",
  "ConfirmNewPasswordLabel": "Confirm new password",
  "ConfirmPasswordLabel": "Confirm password",
  "ConfirmPasswordPlaceholder": "Confirm password",
  "ConfirmYouAreHuman": "Please confirm that you are human.",
  "Coupon": "Coupon",
  "CurrentPasswordLabel": "Current password",
  "CustomerReviews": "Reviews",
  "DateLabel": "Date",
  "Day": "Day",
  "Discount": "Discount",
  "EmailAddressLabel": "Email address",
  "EmailLabel": "Email",
  "EmailPlaceholder": "Enter email",
  "EnterCouponCode": "Enter coupon code",
  "EnterEmail": "Enter email",
  "EnterEmailAddress": "Enter email address",
  "EnterPassword": "Enter password",
  "EnterPhoneNumber": "Enter phone number",
  "EnterTelephone": "Enter phone number",
  "EnterValidEmailAddress": "Enter a valid email address",
  "ErrorBoundaryDescription": "An unexpected error occurred. Please try again.",
  "FavoriteTenants": "Favorites",
  "FaqAccountAnswer": "It's not required, but with an account you get appointment tracking, reminders, and other benefits. Registration is quick and free.",
  "FaqAccountQuestion": "Do I need an account?",
  "FaqCancelAnswer": "Yes, you can cancel an appointment at any time from the My Bookings section.",
  "FaqCancelQuestion": "Can I cancel an appointment?",
  "FaqCitiesAnswer": "We are currently available in multiple cities across Serbia and constantly expanding. Check the city list on the homepage.",
  "FaqCitiesQuestion": "Which cities is the service available in?",
  "FaqFreeAnswer": "Yes, using the platform is completely free for clients. There are no hidden costs.",
  "FaqFreeQuestion": "Is booking free?",
  "FaqTitle": "Frequently Asked Questions",
  "FindPerfect": "Find the perfect",
  "ForgotPasswordLink": "Forgot password?",
  "ForgotPasswordTitle": "Forgot your password?",
  "FullNameLabel": "Full name",
  "FullNamePlaceholder": "Full name",
  "GoToHomePage": "Go to home page",
  "HairLengthLabel": "Hair length",
  "Home": "Home",
  "HowItWorksCtaButton": "Browse services",
  "HowItWorksCtaTitle": "Ready to book?",
  "HowItWorksSubtitle": "Book an appointment in just a few clicks – quickly, easily, and completely free.",
  "HowItWorksTitle": "How it works?",
  "Info": "Info",
  "InvalidEmail": "Please enter a valid email address",
  "InvalidPhoneNumberFormat": "InvalidPhoneNumberFormat",
  "LearnMore": "Learn more about the platform",
  "LoadMore": "Load more",
  "LoadingTip": "Loading...",
  "LoginBrandSubtitle": "Book your appointment quickly and easily, anytime, anywhere.",
  "LoginSubtitle": "Sign in to your account",
  "LogInButton": "Log in",
  "LogInHeader": "Log in",
  "LogOutMenu": "Log out",
  "MenuTitle": "Menu",
  "MessageLabel": "Message",
  "MessagePlaceholder": "Enter a message (optional)",
  "Month": "Month",
  "MoreAboutUs": "More About Us",
  "MorningSlot": "Morning",
  "MyBookingsMenu": "Bookings",
  "MyBookingsTitle": "My bookings",
  "MyProfile": "Profile",
  "UpcomingBooking": "Upcoming booking",
  "NoUpcomingBookings": "No upcoming bookings",
  "NoUpcomingBookingsHint": "Book an appointment in just a few steps",
  "FindSalon": "Find a salon",
  "Today": "Today",
  "Tomorrow": "Tomorrow",
  "Shortcuts": "Shortcuts",
  "QuickActions": "Quick actions",
  "FavoritesTitle": "Favorite salons",
  "FavoritesSubtitle": "Quickly book at the salons you love",
  "NoFavoritesYet": "No favorites yet",
  "NoFavoritesHint": "Tap the heart on a salon to add it here",
  "RemoveFromFavorites": "Remove from favorites",
  "Settings": "Settings",
  "Language": "Language",
  "Support": "Support",
  "HelpMenu": "Help",
  "ContactMenu": "Contact",
  "MaxBookingHint": "Date is outside the allowed booking window",
  "NameLabel": "Name",
  "NamePlaceholder": "Enter name",
  "NewAppointment": "New appointment?",
  "NewPasswordLabel": "New password",
  "Next": "Next",
  "NextStep": "Next",
  "No": "No",
  "NoAnnouncements": "No announcements",
  "NoAnswer": "No",
  "NoBookings": "No bookings",
  "NoBlogPosts": "No published articles",
  "NoData": "No data",
  "NoReviews": "No reviews yet",
  "NoSlotsAvailablePrefix": "Unfortunately",
  "NoSlotsAvailableSuffix": "has no available slots for",
  "NotSure": "Not sure?",
  "NoteLabel": "Note",
  "NotePlaceholder": "Enter note",
  "NonWorkingDayHint": "Non-working day",
  "OrAnotherWorker": "or another worker",
  "OrLabel": "or",
  "SocialLoginInAppHint": "Google and Facebook sign-in only work in Safari or Chrome. Open this page there (··· → Open in external browser) or sign in with email.",
  "PageNotFoundDescription": "The page you are looking for does not exist.",
  "PageNotFoundTitle": "404 - Page not found",
  "PastDateHint": "Date is in the past",
  "PartnerBenefit1": "Online booking",
  "PartnerBenefit2": "Clear calendar",
  "PartnerBenefit3": "Team management",
  "PartnerBenefit4": "Service control",
  "PartnerBenefit5": "Promotions &amp; announcements",
  "PartnerBenefit6": "Mobile app",
  "PartnerHeroSubtitle": "Join the Rasporedi Me platform and let your clients book online. Manage appointments with a clear calendar, control your services, create promotions and announcements — all in one place.",
  "PriceListNotAvailable": "Price list is currently not available.",
  "PriceListTitle": "Price list",
  "PartnerHeroTitle": "Become our partner",
  "PartnerInquirySuccessSubtitle": "Thank you for your interest. We will contact you shortly.",
  "PartnerInquirySuccessTitle": "Inquiry submitted successfully!",
  "PasswordChangeError": "An error occurred while changing the password.",
  "PasswordLabel": "Password",
  "PasswordResetCodeSent": "Password reset instructions have been sent to your email address.",
  "PasswordSuccessfullyChanged": "Password successfully changed.",
  "PhoneLabel": "Phone number",
  "PhoneNumberInvalid": "Please enter a valid phone number",
  "PhoneNumberLabel": "Phone number",
  "PhoneNumberRequired": "Phone number is required",
  "PhonePlaceholder": "Phone number",
  "PleaseSelectAnotherDate": "please select another date",
  "Promotion": "Promotion",
  "Promotions": "Promotions",
  "ProveYouAreHuman": "Prove you are human",
  "PwaGuideAndroidStep1": "Open Rasporedi Me in <b>Chrome</b>.",
  "PwaGuideAndroidStep2": "Tap the <b>⋮</b> menu (three dots) in the top-right corner.",
  "PwaGuideAndroidStep3": "Choose <b>\"Install app\"</b> or <b>\"Add to Home screen\"</b>, then confirm with <b>\"Install\"</b>.",
  "PwaGuideAndroidStep4": "The Rasporedi Me icon appears on your home screen and in the app drawer — open the app from there.",
  "PwaGuideAndroidTip": "<b>Samsung Internet:</b> menu <b>☰</b> → \"Add page to\" → \"Home screen\". If you don't see an install option, update Chrome to the latest version.",
  "PwaGuideButton": "How to",
  "PwaGuideClose": "Close",
  "PwaGuideDesktopStep1": "Open Rasporedi Me in <b>Chrome</b> or <b>Edge</b>.",
  "PwaGuideDesktopStep2": "Click the install icon (a monitor with a downward arrow) at the right end of the address bar.",
  "PwaGuideDesktopStep3": "Don't see it? <b>Chrome</b> menu ⋮ → \"Cast, save and share\" → <b>\"Install page as app\"</b>; <b>Edge</b> menu ⋯ → \"Apps\" → <b>\"Install this site as an app\"</b>.",
  "PwaGuideDesktopStep4": "Confirm with <b>\"Install\"</b>. The app opens in its own window and you can pin it to the taskbar or Dock.",
  "PwaGuideDesktopTip": "<b>Safari on Mac:</b> File menu → <b>\"Add to Dock\"</b>. Firefox doesn't support installing apps — use Chrome or Edge.",
  "PwaGuideInstallNow": "Install now",
  "PwaGuideIntro": "You can install Rasporedi Me as an app in a few seconds — no app store needed. We're showing the guide for your device, but you can pick another one.",
  "PwaGuideIosStep1": "Open Rasporedi Me in <b>Safari</b>.",
  "PwaGuideIosStep2": "Tap the share button (a square with an upward arrow) — at the bottom on iPhone, top-right on iPad. On newer iOS versions tap <b>•••</b> first, then <b>\"Share\"</b>.",
  "PwaGuideIosStep3": "Scroll down and choose <b>\"Add to Home Screen\"</b>.",
  "PwaGuideIosStep4": "Leave <b>\"Open as Web App\"</b> switched on and tap <b>\"Add\"</b> in the top-right corner.",
  "PwaGuideIosStep5": "The Rasporedi Me icon appears on your home screen — open the app from there.",
  "PwaGuideIosTip": "Since iOS 16.4 this also works from Chrome and Edge (share button in the address bar). Some other browsers don't offer it — use Safari in that case.",
  "PwaGuideLink": "How?",
  "PwaGuidePlatformAndroid": "Android",
  "PwaGuidePlatformDesktop": "Computer",
  "PwaGuidePlatformIos": "iPhone",
  "PwaGuideTitle": "How to install the app",
  "PwaInstallAccept": "Install",
  "PwaInstallDescription": "Get faster access and a native feel — add Rasporedi Me to your home screen.",
  "PwaInstallIOSDescription": "Tap the share button, then select \"Add to Home Screen\".",
  "PwaInstallTitle": "Install the app",
  "RateMe": "Rate me",
  "RateUs": "Rate",
  "RegisterMeBtn": "Register",
  "RegisterMeHeader": "Register",
  "RegistrationIllustrationText": "Create an account and book your first appointment in minutes.",
  "RegistrationSubtitle": "Fill in your details below",
  "RegistrationSuccessMessage": "An email with a registration confirmation link has been sent. Please check your email and click the confirmation button to activate your account. Thank you for using our services!",
  "RegistrationTitle": "Registration",
  "RequestSentDescription": "Expect a response within 24h.",
  "RequestSentSuccess": "Your request has been received.",
  "CanCloseThisPage": "You can safely close this page.",
  "RequiredField": "Required field!",
  "SatisfiedWithService": "Are you satisfied with the service?",
  "SaveButton": "Save",
  "ScheduleAppointmentToday": "Schedule an appointment today",
  "ScheduleInFewClicks": "Schedule an appointment in a few clicks, quickly and easily.",
  "Search": "Search",
  "SearchByName": "Search by name",
  "SearchServices": "Search services",
  "SearchWorker": "Search staff",
  "ClearAll": "Clear all",
  "NoServicesFound": "No services match your search",
  "NoResultsFound": "No results found",
  "NoCategories": "No categories available yet",
  "NoServicesInCity": "No services available in this city yet",
  "SeeAll": "See all",
  "SeeReviews": "See reviews",
  "SelectRating": "Select a rating",
  "SelectServices": "Select services",
  "SelectTown": "Select town",
  "SelectWorker": "Select a worker",
  "SendResetLink": "Send reset link",
  "ServiceCategories": "Service categories",
  "ServiceForYou": "service for you",
  "ServicesLabel": "Services",
  "SignInWithFacebook": "Sign in with Facebook",
  "SomethingWentWrong": "Something went wrong",
  "SortBy": "Sort by",
  "SortName": "Name A–Z",
  "SortNewest": "Newest",
  "SortRating": "Highest rated",
  "SortRecommended": "Recommended",
  "StepBookDesc": "Choose a date and time that works for you and confirm the appointment.",
  "StepBookTitle": "Book appointment",
  "StepChooseDesc": "Select the service category you need — hairdressers, beauticians, nails, and much more.",
  "StepChooseTitle": "Choose a service",
  "StepConfirmDesc": "You will receive a confirmation and a reminder before your scheduled appointment.",
  "StepConfirmTitle": "Confirmation",
  "StepPickDesc": "Browse profiles, ratings, and reviews to find the best service provider.",
  "StepPickTitle": "Find a salon",
  "StatusCanceled": "Canceled",
  "StatusConfirmed": "Confirmed",
  "StatusNoShow": "No Show",
  "StatusPending": "Pending",
  "Submit": "Submit",
  "SubmitPartnerInquiry": "Submit inquiry",
  "SubmitRequest": "Submit request",
  "SubmitRequestError": "An error occurred while sending the request! Please try again.",
  "SuccessfulRegistration": "Successful registration!",
  "SuccessfullyAdded": "Successfully added",
  "SuccessfullyChanged": "Successfully changed",
  "SurnameLabel": "Last Name",
  "SurnamePlaceholder": "Enter last name",
  "SurveyAnonymousNotice": "Your answers are completely anonymous",
  "TabPast": "History",
  "TabUnassigned": "Requests",
  "TabUpcoming": "Bookings",
  "PrivacyPolicy": "Privacy Policy",
  "TelephoneLabel": "Phone",
  "TermsAndConditionsTitle": "Terms of Service",
  "TermsOfService": "terms of service",
  "ThankYouForFeedback": "Thank you for your feedback!",
  "ThankYouForServices": "Thank you for using our services!",
  "TimeLabel": "Time",
  "Town": "Town",
  "TownLabel": "Town",
  "Unscheduled": "Unscheduled",
  "UnavailabilityHint": "Unavailable (time off)",
  "VerificationFailed": "Unsuccessful verification!",
  "VerificationFailedMessage": "Unsuccessful verification! Please try again. Thank you for using our services!",
  "VerificationSuccess": "Successful verification!",
  "VerificationSuccessMessage": "You have successfully verified your account. You can now log in. Thank you for using our services!",
  "ViewCategory": "View",
  "Welcome": "Welcome",
  "WhyRasporediMe": "Why Rasporedi Me?",
  "WorkerLabel": "Worker",
  "Year": "Year",
  "Yes": "Yes",
  "YesAnswer": "Yes",
  "YourAnswer": "Your answer",
  "PricingTitle": "Pricing",
  "PricingSubtitle": "Simple pricing, no hidden fees. All plans include unlimited bookings.",
  "PricingMonthly": "month",
  "PricingPopular": "Most popular",
  "PricingSolo": "Solo",
  "PricingSoloSubtitle": "For individuals",
  "PricingSoloDesc": "No notebook, no missed calls — just work",
  "PricingSalon": "Salon",
  "PricingSalonSubtitle": "Best choice for salons with 2+ workers",
  "PricingSalonDesc": "On average +20–30% more bookings with fewer no-shows",
  "PricingLanac": "Chain",
  "PricingLanacSubtitle": "For multiple locations and serious growth",
  "PricingLanacDesc": "Custom pricing — tailored to your business",
  "PricingCustom": "Custom pricing",
  "PricingTrust": "No contract · Cancel anytime",
  "PricingTryFree": "Start accepting online bookings",
  "PricingStartSalon": "Get more bookings",
  "PricingContact": "Automate your business",
  "PricingFeatureBooking247": "Clients book themselves, 24/7",
  "PricingFeatureUnlimitedServices": "Unlimited services & bookings",
  "PricingFeatureReminders": "Reminders reduce no-shows",
  "PricingFeatureCustomers": "Customer management",
  "PricingFeaturePush": "Push notifications",
  "PricingFeatureTrial": "14-day free trial",
  "PricingFeatureUnlimitedWorkers": "Unlimited workers — each with own schedule",
  "PricingFeatureStats": "Earnings per worker — who brings the most",
  "PricingFeatureWorkerSelection": "Clients pick their favorite worker",
  "PricingFeatureCouponsPromo": "Coupons & promos fill empty slots",
  "PricingFeatureSurveys": "Customer feedback surveys",
  "PricingFeatureTurnover": "Revenue & expense tracking",
  "PricingFeatureOwnBrand": "Your own logo — your brand",
  "PricingFeatureAllSalon": "Everything in Salon plan",
  "PricingFeatureSms": "SMS reminders for clients (coming soon)",
  "PricingFeatureExport": "Data export & advanced analytics",
  "PricingFeatureApi": "API for system integrations",
  "PricingFeatureLocations": "Multiple locations under one account",
  "PricingFeaturePriority": "Priority support — 2h response",
  "WhatAreYouLookingFor": "Service?",
  "Where": "City?",
  "SearchAction": "Search",
  "MyLocation": "My location",
  "LocationUnavailable": "Location unavailable. Please choose a city manually.",
  "NoNearbyTown": "No available city near you. Please choose a city manually.",
  "TopRatedSalons": "Top rated salons",
  "SlideOf": "Slide {{n}} of {{total}}",
  "ChooseService": "Choose a service",
  "FooterServices": "Services",
  "FooterCities": "Salons by city",
  "FooterGeneral": "General information",
  "TopRatedInCity": "Top rated in {{place}}",
  "ShowAllSalonsInCity": "Show all salons in {{place}} ({{count}})",
  "AllSalonsInCity": "All salons in {{place}}",
  "CookieBannerTitle": "Cookies and privacy",
  "CookieBannerText": "We use cookies to measure visits and show relevant ads. The site works the same without them.",
  "CookieBannerPolicy": "Privacy policy",
  "CookieAccept": "Accept",
  "CookieDecline": "Necessary only"
}
